// extracted by mini-css-extract-plugin
export default {"main":"UnifiedSearch_main__fXZ-M","input":"UnifiedSearch_input__d1oZe","placeholder":"UnifiedSearch_placeholder__yfEzv","logo":"UnifiedSearch_logo__Z3YUj"};